import { xCheck } from './xCheck';
import { xGetFromToIndex } from './xGetFromToIndex';
/**
 * Computes the index of the maximum of the given values
 * @param array - array of numbers
 * @param  options - options
 * @returns - index
 */
export function xMaxIndex(array, options = {}) {
    xCheck(array);
    const { fromIndex, toIndex } = xGetFromToIndex(array, options);
    let maxIndex = fromIndex;
    for (let i = fromIndex + 1; i <= toIndex; i++) {
        if (array[i] > array[maxIndex]) {
            maxIndex = i;
        }
    }
    return maxIndex;
}
//# sourceMappingURL=xMaxIndex.js.map